import { createI18n } from 'vue-i18n'
import { getStorage } from '@/utils/storage'
import commonZh from './pages/common/zh'
import commonEn from './pages/common/en'
import commonVn from './pages/common/vn'
import pagesLoginZh from './pages/login/zh'
import pagesLoginEn from './pages/login/en'
import pagesLoginVn from './pages/login/vn'
import pagesHomeZh from './pages/home/zh'
import pagesHomeEn from './pages/home/en'
import pagesHomeVn from './pages/home/vn'
import pagesGamesZh from './pages/games/zh'
import pagesGamesEn from './pages/games/en'
import pagesGamesVn from './pages/games/vn'
import pagesOrderssZh from './pages/orders/zh'
import pagesOrdersEn from './pages/orders/en'
import pagesOrdersVn from './pages/orders/vn'
import pagesSystemsZh from './pages/systems/zh'
import pagesSystemsEh from './pages/systems/en'
import pagesSystemsVn from './pages/systems/vn'
import pagesUserZh from './pages/user/zh'
import pagesUserEn from './pages/user/en'
import pagesUserVn from './pages/user/vn'
import pagesDatasZh from './pages/datas/zh'
import pagesDatasEn from './pages/datas/en'
import pagesDatasVn from './pages/datas/vn'
import pagesNoticeZh from './pages/notice/zh'
import pagesNoticeEn from './pages/notice/en'
import pagesNoticeVn from './pages/notice/vn'
import pagesOperateZh from './pages/operate/zh'
import pagesOperateEn from './pages/operate/en'
import pagesOperateVn from './pages/operate/vn'
import pagesActivityZh from './pages/activity/zh'
import pagesActivityEn from './pages/activity/en'
import pagesActivityVn from './pages/activity/vn'
export default createI18n({
  legacy: false, // 让 setup 函数可以通过 t 访问
  globalInjection: true, // 让 template 可以像 vue2 那样使用{{$t("")}}来访问
  locale: getStorage('language') || 'zh', // 定义默认语言为中文
  fallbackLocale: 'zh',
  messages: {
    'zh': {
      ...commonZh,
      ...pagesLoginZh,
      ...pagesHomeZh,
      ...pagesUserZh,
      ...pagesGamesZh,
      ...pagesOrderssZh,
      ...pagesDatasZh,
      ...pagesSystemsZh,
      ...pagesNoticeZh,
      ...pagesOperateZh,
      ...pagesActivityZh,
    },
    'en': {
      ...commonEn,
      ...pagesLoginEn,
      ...pagesHomeEn,
      ...pagesGamesEn,
      ...pagesOrdersEn,
      ...pagesUserEn,
      ...pagesDatasEn,
      ...pagesSystemsEh,
      ...pagesNoticeEn,
      ...pagesOperateEn,
      ...pagesActivityEn,
    },
    'vn': {
      ...commonVn,
      ...pagesLoginVn,
      ...pagesHomeVn,
      ...pagesGamesVn,
      ...pagesOrdersVn,
      ...pagesUserVn,
      ...pagesDatasVn,
      ...pagesSystemsVn,
      ...pagesNoticeVn,
      ...pagesOperateVn,
      ...pagesActivityVn,
    }
  }
})
